<template>
  <div v-show="beginsAt && closesAt">
    <span class="drop-shadow">
      受講開始<span class="co-display-8 mx-1 font-bold">
        {{ beginsMonth }}
      </span>月<span class="co-display-8 mx-1 font-bold">
        {{ beginsDays }}
      </span>日 （{{ beginsDayOfWeek }})
    </span>
    <span class="block">
      <TeCommonBalloon
        v-show="showNotification === 'today'"
        class="border-co-gray-50/20 bg-co-gray-50/20 px-5"
      >
        <img
          src="~/assets/images/Te/TeCourse/CoverTimeSpan/icon-flame.svg"
          class="mb-1 inline pr-1"
        >
        本日締切
        <span class="co-display-8 mx-1 font-bold">
          {{ closesMonth }}
        </span>月
        <span class="co-display-8 mx-1 font-bold">
          {{ closesDays }}
        </span>日 （{{ closesDayOfWeek }})
        <span class="co-display-8 mx-1 font-bold">
          {{ closesHours }}
        </span>時
      </TeCommonBalloon>
      <TeCommonBalloon
        v-show="showNotification === 'aLittleLeft'"
        class="border-co-gray-50/20 bg-co-gray-50/20 px-5"
      >
        <img
          src="~/assets/images/Te/TeCourse/CoverTimeSpan/icon-flame.svg"
          class="mb-1 inline pr-1"
        >
        締切間近
        <span class="co-display-8 mx-1 font-bold">
          {{ closesMonth }}
        </span>月
        <span class="co-display-8 mx-1 font-bold">
          {{ closesDays }}
        </span>日 （{{ closesDayOfWeek }})
        <span class="co-display-8 mx-1 font-bold">
          {{ closesHours }}
        </span>時
      </TeCommonBalloon>
      <span
        v-show="showNotification === 'left'"
        class="px-5 py-4 drop-shadow"
      >
        申込締切<span class="co-display-8 mx-1 font-bold">
          {{ closesMonth }}
        </span>月
        <span class="co-display-8 mx-1 font-bold">
          {{ closesDays }}
        </span>日 （{{ closesDayOfWeek }})
        <span class="co-display-8 mx-1 font-bold">
          {{ closesHours }}
        </span>時
      </span>
    </span>
    <a
      class="co-btn-ghost-white mt-5 rounded-full border bg-co-gray-50 tracking-widest !text-co-gray-700 hover:!bg-co-gray-50"
      href="#apply"
      style="width: 283px"
      @click.prevent="scrollTo('apply')"
    >
      今すぐ申し込む
    </a>
  </div>
</template>

<script lang="ts">
import { defineNuxtComponent } from '#app'
import { formatDayOfWeek, dateToYesterday } from '~/utility/utility'
import TeCommonBalloon from '~/components/Te/TeCommon/Balloon/TeCommonBalloon/TeCommonBalloon.vue'
import { scrollTo } from '~/composables/useSmoothScroll'

const options = {
  props: {
    beginsAt: {
      type: Date,
      default: null,
    },
    closesAt: {
      type: Date,
      default: null,
    },
  },
  computed: {
    closesHours() {
      if (!this.closesAt) {
        return 0
      }
      return this.closesAt.getHours() + 24
    },
    closesDays() {
      if (!this.closesAt) {
        return 0
      }
      if (this.closesAt.getDate() === 1) {
        const yesterday = new Date(this.closesAt)
        yesterday.setDate(yesterday.getDate() - 1)
        return yesterday.getDate()
      }
      return this.closesAt.getDate() - 1
    },
    closesMonth() {
      if (!this.closesAt) {
        return 0
      }
      if (this.closesAt.getDate() === 1) {
        const yesterday = new Date(this.closesAt)
        yesterday.setDate(yesterday.getDate() - 1)
        return yesterday.getMonth() + 1
      }
      return this.closesAt.getMonth() + 1
    },
    closesDayOfWeek() {
      if (!this.closesAt) {
        return '日' as '日' | '月' | '火' | '水' | '木' | '金' | '土' | '祝'
      }
      const dayOfWeek = formatDayOfWeek(dateToYesterday(this.closesAt), false)

      return dayOfWeek as '日' | '月' | '火' | '水' | '木' | '金' | '土' | '祝'
    },
    beginsMonth() {
      return this.beginsAt ? this.beginsAt.getMonth() + 1 : 0
    },
    beginsDays() {
      return this.beginsAt ? this.beginsAt.getDate() : 0
    },
    beginsDayOfWeek() {
      if (!this.beginsAt) {
        return '日' as '日' | '月' | '火' | '水' | '木' | '金' | '土' | '祝'
      }
      const dayOfWeek = formatDayOfWeek(this.beginsAt, false)

      return dayOfWeek as '日' | '月' | '火' | '水' | '木' | '金' | '土' | '祝'
    },
    showNotification() {
      if (!this.closesAt) {
        return 'left'
      }
      const now = new Date()
      const leftDays =
        (this.closesAt.valueOf() - now.valueOf()) / (1000 * 60 * 60 * 24)
      if (leftDays > 0 && leftDays < 1) {
        return 'today'
      } else if (leftDays > 1 && leftDays < 3) {
        return 'aLittleLeft'
      } else {
        return 'left'
      }
    },
  },
  components: {
    TeCommonBalloon,
  },
}

export default defineNuxtComponent(options)
</script>
